export default "__VITE_ASSET__d7abd2e2__"